<template>
  <div class="mobileFaceVerification">
    <van-nav-bar class="userNavBar"
                 @click-left="onClickLeft"
                 title="实名认证"
                 left-arrow>
      <template #left>
        <van-icon name="../../../static/images/mobile/back.png"
                  size="18" />
      </template>
    </van-nav-bar>
    <div class="faceTitle">请确保脸部清晰光线充足</div>
    <div class="facepic">
      <div>
        <img src="../../../static/images/mobile/faceintroduce.png"
             alt="" />
      </div>
    </div>
    <div class="startPic">
      <van-button @click="baiDuFace()"
                  type="danger">开始拍照</van-button>
    </div>
    <div @click="showPopup"
         class="standard">查看规范</div>
    <van-popup class="standardPic"
               v-model="show">
      <div class="standardPic-title">人像拍照规范</div>
      <img src="../../../static/images/mobile/standard.png"
           alt="" />
      <van-button @click="hidePopup"
                  plain
                  type="primary">我知道了</van-button>
    </van-popup>
    <!-- <van-uploader type="file" accept="image/*" mutiple="mutiple" capture="camera" :after-read="afterRead" /> -->
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  data() {
    return {
      pic: '',
      picture: '',
      from: '',
      h5faceId: '',
      nonce: '',
      orderNo: '',
      sign: '',
      userId: '',
      version: '',
      webankAppId: '',
      pictures: '',
      idCard: '',
      userId: '',
      realName: '',
      show: false,
      faceList: '',
      type: localStorage.getItem('type')
    }
  },
  methods: {
    // 新增百度人脸
    baiDuFace() {
      let param = {}
      param.username = localStorage.getItem('realName')
      param.idCard = localStorage.getItem('idCard')
      //   param.linkUrl = `https://itest27.chinahrt.com/index.html#/mobileBaiDuFace?type=${this.type}`\
      param.linkUrl =
        window.location.protocol +
        '//' +
        window.location.host +
        '/index.html#/' +
        'mobileBaiDuFace?type=' +
        this.type +
        ''
      this.$api.get('/user/brainBaiduFace', param, (res) => {
        if (res.code == 'SUCCESS') {
          let url = new URL(res.data)
          let params = new URLSearchParams(url.search)
          this.$sessionStore.setVerifyToken(params.get('token'))
          this.$sessionStore.setAccessToken(params.get('access_token'))
          window.location.href = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    showPopup() {
      this.show = true
    },
    hidePopup() {
      this.show = false
    }
  },
  created() {}
}
</script>
<style>
.mobileFaceVerification .van-overlay {
  background-color: rgb(0 0 0) !important;
}
</style>
<style scoped>
.faceintroduce {
  margin-left: 0.426667rem;
  margin-top: 0.32rem;
  color: #555555;
  font-weight: 400;
  font-size: 0.373333rem;
}
.facepic img {
  width: 6.613333rem;
  height: 6.613333rem;
}
.facepic {
  display: flex;
  justify-content: space-around;
  margin-bottom: 0.8rem;
  margin-top: 0.64rem;
}
.faceTitle {
  margin-top: 0.64rem;
  text-align: center;
  font-size: 0.426667rem;
}
.van-button {
  width: 9.146667rem;
  height: 1.28rem;
  border-radius: 0.64rem;
}
.startPic {
  text-align: center;
}
.standard {
  text-align: center;
  margin-top: 0.533333rem;
}
.van-popup img {
  width: 6.64rem;
  height: 7.333333rem;
}
.van-popup .van-button {
  color: #ffffff;
  border: 0.026667rem solid #ffffff;
  border-radius: 0.106667rem;
  background: none;
  margin-top: 0.64rem;
  width: 6.64rem;
  height: 1.28rem;
}
.standardPic {
  background: none;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.standardPic-title {
  color: #ffffff;
  font-size: 0.453333rem;
  text-align: center;
  margin-bottom: 0.64rem;
}
.van-popup--center {
  top: 35%;
}
</style>


// WEBPACK FOOTER //
// MobileFaceVerification.vue?7d8a0b17